module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "flex-content"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("reset")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.selectItem
    }
  }, [_vm._v("select from parent")])]), _vm._v(" "), _c('div', [_c('list-select', {
    attrs: {
      "list": _vm.someList,
      "option-value": "code",
      "option-text": "name",
      "custom-text": _vm.codeAndNameAndDesc,
      "selected-item": _vm.item
    },
    on: {
      "select": _vm.onSelect
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-result"
  }, [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.item.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.desc))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("desc")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78dae7ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sample/List/ListCustomText.vue
// module id = 397
// module chunks = 2